 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTML02_COPYRIGH from '@/components/xhtml/02_Copyrigh'
 import XHTML01_TITLE_PA from '@/components/xhtml/01_Title_Pa'
 import XHTML03_DEDICATI from '@/components/xhtml/03_Dedicati'
 import XHTML04_CONTENTS from '@/components/xhtml/04_Contents'
 import XHTML05_CAST_OF from '@/components/xhtml/05_CAST_OF'
 import XHTML06_PROLOGUE from '@/components/xhtml/06_PROLOGUE'
 import XHTML07_PART_1_ from '@/components/xhtml/07_PART_1_'
 import XHTML08_1__DICK from '@/components/xhtml/08_1__DICK'
 import XHTML09_2__EVERY from '@/components/xhtml/09_2__EVERY'
 import XHTML10_3__CHICA from '@/components/xhtml/10_3__CHICA'
 import XHTML11_PART_2_ from '@/components/xhtml/11_PART_2_'
 import XHTML12_4__FROM from '@/components/xhtml/12_4__FROM'
 import XHTML13_5__DARWI from '@/components/xhtml/13_5__DARWI'
 import XHTML14_6__MAYOR from '@/components/xhtml/14_6__MAYOR'
 import XHTML15_PART_3_ from '@/components/xhtml/15_PART_3_'
 import XHTML16_7__ALL_H from '@/components/xhtml/16_7__ALL_H'
 import XHTML17_8__RESTO from '@/components/xhtml/17_8__RESTO'
 import XHTML18_9__CHICA from '@/components/xhtml/18_9__CHICA'
 import XHTML19_10__A_NE from '@/components/xhtml/19_10__A_NE'
 import XHTML20_PART_4_ from '@/components/xhtml/20_PART_4_'
 import XHTML21_11__CRIM from '@/components/xhtml/21_11__CRIM'
 import XHTML22_12__TAKE from '@/components/xhtml/22_12__TAKE'
 import XHTML23_PART_5_ from '@/components/xhtml/23_PART_5_'
 import XHTML24_13__HAS from '@/components/xhtml/24_13__HAS'
 import XHTML25_14__HOUS from '@/components/xhtml/25_14__HOUS'
 import XHTML26_15__BILL from '@/components/xhtml/26_15__BILL'
 import XHTML27_PART_6_ from '@/components/xhtml/27_PART_6_'
 import XHTML28_16__CROS from '@/components/xhtml/28_16__CROS'
 import XHTML29_17__THE from '@/components/xhtml/29_17__THE'
 import XHTML30_18__MILL from '@/components/xhtml/30_18__MILL'
 import XHTML31_19__CORR from '@/components/xhtml/31_19__CORR'
 import XHTML32_PART_7_ from '@/components/xhtml/32_PART_7_'
 import XHTML33_20__GLOB from '@/components/xhtml/33_20__GLOB'
 import XHTML34_21__ONE from '@/components/xhtml/34_21__ONE'
 import XHTML35_22__SISY from '@/components/xhtml/35_22__SISY'
 import XHTML36_23__BLOO from '@/components/xhtml/36_23__BLOO'
 import XHTML37_24__SUNR from '@/components/xhtml/37_24__SUNR'
 import XHTML38_APPENDIX from '@/components/xhtml/38_APPENDIX'
 import XHTML39_APPENDIX from '@/components/xhtml/39_APPENDIX'
 import XHTML40_APPENDIX from '@/components/xhtml/40_APPENDIX'
 import XHTML41_ACKNOWLE from '@/components/xhtml/41_ACKNOWLE'
 import XHTML42_NOTES from '@/components/xhtml/42_NOTES'
 import XHTML43_INDEX from '@/components/xhtml/43_INDEX'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/04_Contents",
 			"name" : "xhtml/04_Contents",
 			"component" : XHTML04_CONTENTS
 		},
 		{
 			"path" : "/xhtml/05_CAST_OF",
 			"name" : "xhtml/05_CAST_OF",
 			"component" : XHTML05_CAST_OF
 		},
 		{
 			"path" : "/xhtml/06_PROLOGUE",
 			"name" : "xhtml/06_PROLOGUE",
 			"component" : XHTML06_PROLOGUE
 		},
 		{
 			"path" : "/xhtml/07_PART_1_",
 			"name" : "xhtml/07_PART_1_",
 			"component" : XHTML07_PART_1_
 		},
 		{
 			"path" : "/xhtml/08_1__DICK",
 			"name" : "xhtml/08_1__DICK",
 			"component" : XHTML08_1__DICK
 		},
 		{
 			"path" : "/xhtml/09_2__EVERY",
 			"name" : "xhtml/09_2__EVERY",
 			"component" : XHTML09_2__EVERY
 		},
 		{
 			"path" : "/xhtml/10_3__CHICA",
 			"name" : "xhtml/10_3__CHICA",
 			"component" : XHTML10_3__CHICA
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js